import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CreateExportDialogComponent } from '@client/app/shared-modules/create-export/components/create-export-dialog/create-export-dialog.component';
import { CreateExport } from '@client/app/shared-modules/create-export/types/create-export.type';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class CreateExportDialogService {
    private dialogRef: DynamicDialogRef | null = null;
    private triggerElement: HTMLElement | null = null;

    constructor (
        private readonly dialogService: DialogService,
        private readonly translocoService: TranslocoService,
    ) {}

    open (config: CreateExport): DynamicDialogRef {
        if (this.dialogRef) {
            this.dialogRef.close();
        }

        this.triggerElement = (document.activeElement instanceof HTMLElement) ? document.activeElement : null;

        this.dialogRef = this.dialogService.open(CreateExportDialogComponent, {
            header: this.translocoService.translate('createExport.dialog.header'),
            width: '900px',
            modal: true,
            closable: true,
            dismissableMask: true,
            resizable: false,
            draggable: false,
            baseZIndex: 10000,
            data: { config },
        });

        this.dialogRef.onClose.subscribe(() => {
            this.triggerElement?.focus();
            this.triggerElement = null;
            this.dialogRef = null;
        });

        return this.dialogRef;
    }

    close (): void {
        if (this.dialogRef) {
            this.dialogRef.close();
            this.dialogRef = null;
        }
    }
}
